export type ApiMode = 'mock' | 'http';

export interface RuntimeConfig {
  apiMode: ApiMode;
  apiUrl: string;
  parentOrigin: string;
  mockDelayMs: number;
}

const toOrigin = (value: string | undefined, fallback: string) => {
  try {
    return new URL(value ?? fallback).origin;
  } catch {
    return fallback;
  }
};

export const runtimeConfig: RuntimeConfig = {
  apiMode: import.meta.env.VITE_FORM_API_MODE === 'http' ? 'http' : 'mock',
  apiUrl:
    import.meta.env.VITE_FORM_API_URL ??
    'https://integrations.lincolns.com.uy/api/form',
  parentOrigin: toOrigin(
    import.meta.env.VITE_PARENT_ORIGIN,
    'https://www.lincolns.com.uy',
  ),
  mockDelayMs: 450,
};
